/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PersonType = {
    Regular: 'regular',
    Anonymous: 'anonymous'
} as const;
export type PersonType = typeof PersonType[keyof typeof PersonType];


export function PersonTypeFromJSON(json: any): PersonType {
    return PersonTypeFromJSONTyped(json, false);
}

export function PersonTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonType {
    return json as PersonType;
}

export function PersonTypeToJSON(value?: PersonType | null): any {
    return value as any;
}

